module.exports = __webpack_public_path__ + "img/adminsoft.614690fd.jpg";